import { Component} from 'react';
import {Dictionary} from "lodash";
import {
    Client as GraphClient,
} from "@microsoft/microsoft-graph-client";
import ApiService from "../ApiService";
import ListUserAccessRecordsPage from "../pages/admin/ListUserAccessRecordsPage";

interface AllocateTenantRolloverDataProviderProps
{
    apiService: ApiService;
    graphClient: GraphClient;
    
    children(data: AllocateTenantRolloverData): any;
}

export interface AllocateTenantRolloverData
{
    availableAgentIds: string[];
    agentUserDict: Dictionary<{displayName: string,userPrincipalName: string}>
}

export class AllocateTenantRolloverDataProvider extends Component<AllocateTenantRolloverDataProviderProps, Partial<AllocateTenantRolloverData>> {
    static displayName = AllocateTenantRolloverDataProvider.name;

    constructor(props: AllocateTenantRolloverDataProviderProps) {
        super(props);

        this.state = {
        }
    }

    async componentDidMount()
    {
        const agentIds = await this.props.apiService.getRolloverAgentIds();
        const userDict = await ListUserAccessRecordsPage.getUserDict(agentIds, this.props.graphClient);

        this.setState({
            availableAgentIds: agentIds,
            agentUserDict: userDict
        });
    }
    
    render()
    {
        if(this.state.availableAgentIds === undefined || this.state.agentUserDict === undefined)
        {
            return null;
        }
        
        return this.props.children(this.state as AllocateTenantRolloverData);
    }
}

